// GENERATE BY ../scripts/generate.js
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
import React, { forwardRef, MutableRefObject } from 'react';
import { IconProps } from '../type';
import classNames from 'classnames';
import useConfig from '../../_util/useConfig';
import useSizeProps from '../useSizeProps';

const LoadingIcon = (props: IconProps, ref: MutableRefObject<SVGSVGElement>) => {
  const { classPrefix } = useConfig();
  const { size, className: customClassName, style: customStyle, ...restProps } = props;
  const { className: sizeClassName, style: sizeStyle } = useSizeProps(size);
  const className = classNames(classPrefix + '-icon',classPrefix+'-icon-loading', sizeClassName, customClassName);
  const style = { ...customStyle, ...sizeStyle }

  return (
    <svg ref={ref} className={className} style={style} {...restProps} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path fillOpacity=".9" fillRule="evenodd" d="M96 512C96 282.264 282.264 96 512 96 741.736 96 928 282.264 928 512L824 512 824 512C824 339.68715776 684.3128448 200 512 200 339.68715776 200 200 339.68715776 200 512 200 684.3128448 339.68715776 824 512 824L512 928C282.264 928 96 741.736 96 512Z"/></svg>
  )
};

LoadingIcon.displayName = 'LoadingIcon';

export default forwardRef<SVGSVGElement, IconProps>(LoadingIcon);
